import React from "react";
import PropTypes from "prop-types";

function TimelineItem({ header, title, icon, button }) {
  return (
    <div className="item event-list">
      <div>
        <div className="event-date">
          {header && (
            <div className={`text-${header.color} mb-1`}>{header.text}</div>
          )}
          <h5 className="mb-4">{title}</h5>
        </div>
        <div className="event-down-icon">
          <i
            className={`${icon.icon} h1 text-${icon.color} down-arrow-icon`}
          ></i>
        </div>
        <div className="mt-3 px-3 pb-3">{button}</div>
      </div>
    </div>
  );
}

TimelineItem.propTypes = {
  header: PropTypes.shape({
    text: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
  }).isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
  }).isRequired,
  button: PropTypes.node.isRequired,
};

export default TimelineItem;
